// extracted by mini-css-extract-plugin
export default {"wrapper":"ThlgqY0bMPDY6npOkWoP","viewLink":"FEa7zpVcf2hkTCWy709s","icon":"MHwwZT3NTlrefUYATqTW"};